import { SiGitconnected } from "react-icons/si";
import { onModuleContent } from "../_Resources/Content/Module.Resources";
import { AuthLoginViewMain } from "../Components/Login/AuthLoginViewMain";
import { AuthVerifyCodeViewMain } from "../Components/VerifyCode/AuthVerifyCodeViewMain";

export const AuthModule = (DATA_USER_AUTH = null, lang = "es") => {

    const RESOURCES = onModuleContent(lang);

    return [
        {
            views: "PUBLIC", path: "/ingresar", component: <AuthLoginViewMain />,
            roles: null, permissions: null, label: RESOURCES.LABEL, icon: <SiGitconnected />,
            displayInHeader: false, displayInFooter: false, displayInSidebar: false,
            isBlockedWhenLogged: true,
        },
        {
            views: "PUBLIC", path: "/verificar-codigo", component: <AuthVerifyCodeViewMain />,
            roles: null, permissions: null, label: "Verificar acceso", icon: <SiGitconnected />,
            displayInHeader: false, displayInFooter: false, displayInSidebar: false,
            isBlockedWhenLogged: true,
        },
    ];
};
